import Button from 'Shared/components/Button'
import Modal from 'Shared/components/Modal/Modal'
import CopyToClipboard from 'Shared/components/CopyToClipboard'
import restClient from 'Shared/hooks/restClient'
import Flash from 'Shared/components/Flash/components/Flash'
import ManageMenuComponent from 'Shared/components/ManageMenu/ManageMenuComponent'
import { ManageMenuItem } from 'Shared/components/ManageMenu'
import CompleteGoalModal from './modals/CompleteGoalModal'
import UpdateSubscriptionModal from './modals/UpdateSubscriptionModal'
import UpdateMembershipStatusModal from './modals/UpdateMembershipStatusModal'
import RemoveModal from './modals/RemoveModal'

export default function AudienceActions({ searchId, canExport, canImport }) {
  const [exportPassword, setExportPassword] = useState(null)
  const [completeModalOpen, setCompleteModalOpen] = useState(false)
  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false)
  const [removeModalOpen, setRemoveModalOpen] = useState(false)
  const [membershipStatusModalOpen, setMembershipStatusModalOpen] = useState(false)
  const [flash, setFlash] = useState(null)

  const bulkActions: ManageMenuItem[] = [
    {
      title: 'Complete Goal',
      onClick: () => {
        setCompleteModalOpen(true)
      },
    },
    {
      title: 'Update Subscription',
      onClick: () => {
        setSubscriptionModalOpen(true)
      },
    },
    {
      title: 'Update Membership Status',
      onClick: () => {
        setMembershipStatusModalOpen(true)
      },
    },
  ]

  if (canImport) {
    bulkActions.push({
      title: 'Permanently Delete',
      onClick: () => {
        setRemoveModalOpen(true)
      },
    })
  }

  const doExport = () => {
    restClient.post(`/api/searches/${searchId}/export`).then(({ data: { password } }) => {
      setExportPassword(password)
    })
  }

  const runBulkAction = (action, parameters) => {
    return restClient
      .post(`/api/bulk_actions/launch`, {
        ids: [searchId],
        bulk_action: {
          actions: [{ action: action, parameters: parameters }],
        },
      })
      .then(() => {
        setCompleteModalOpen(false)
        setSubscriptionModalOpen(false)
        setRemoveModalOpen(false)
        setMembershipStatusModalOpen(false)
        setFlash({
          message: 'Thanks, this will happen over the next few minutes.',
          type: 'success',
        })
      })
  }

  return (
    <div className="actions">
      {canExport && (
        <>
          <Button extraClass="margin-right" primary onClick={doExport}>
            <SvgIconsDownload />
            Export Audience
          </Button>

          <Modal
            open={!!exportPassword}
            title="Export in progress"
            onCancel={() => setExportPassword(null)}
          >
            The audience is exporting. You'll receive an email when it's done. Use this
            password to open it: &nbsp;
            <CopyToClipboard
              text={`${exportPassword} (click to copy)`}
              url={exportPassword}
            />
          </Modal>
        </>
      )}

      <ManageMenuComponent items={bulkActions} components={null} title="Bulk Actions" />

      {flash && (
        <Flash message={flash.message} type={flash.type} onHide={() => setFlash(null)} addClass="flash-right-align" />
      )}

      <CompleteGoalModal
        open={completeModalOpen}
        onCancel={() => setCompleteModalOpen(false)}
        onConfirm={({ effortId }) => runBulkAction('complete_goal', { effortId })}
      />

      <UpdateSubscriptionModal
        open={subscriptionModalOpen}
        onCancel={() => setSubscriptionModalOpen(false)}
        onConfirm={(params) => runBulkAction('update_subscription', params)}
      />

      <UpdateMembershipStatusModal
        open={membershipStatusModalOpen}
        onCancel={() => setMembershipStatusModalOpen(false)}
        onConfirm={({ membershipStatus }) => runBulkAction('update_membership_status', { membershipStatus })}
      />

      <RemoveModal
        open={removeModalOpen}
        onCancel={() => setRemoveModalOpen(false)}
        onConfirm={() => runBulkAction('remove', {})}
      />
    </div>
  )
}
